
import moment from "moment";
import React, { useMemo, useState } from "react";
import { Card, Table } from "react-bootstrap";

import { getTaskMonths } from "../../Helpers/TasksHelper";

import KanbanMonth from "../../Components/Kanban/KanbanMonth";

import './TasksGroupByMonth.scss'

type Props = {
  height: number;
  tasks: any;
  teams: any;

  onSelectTask: (task_id: string) => void;
}

const TasksGroupByMonth = (props: Props) => {

  const getAllTasksFromList = (list: any) => {

    const tasks: any[] = []

    list.forEach((item: any) => {

      if (item.type === 'task') {

        tasks.push(item.task)
      } else {

        const subTasks = getAllTasksFromList(item.group.items)

        if (subTasks.length)
          tasks.push(...subTasks)
      }
    })

    return tasks
  }

  const groupedByMonth = useMemo(() => {

    const allTasks = getAllTasksFromList(props.tasks)

    const months: any = {}

    allTasks.map((task: any) => {

      const task_months: any = getTaskMonths(task)

      task_months.map((month: string) => {

        if (!months[month]) {

          months[month] = []
        }

        months[month].push(task)
      })
    })

    const groups: any = []

    for (const key in months) {

      groups.push({
        name: moment(`${key}`).format('MMMM - YYYY'),
        tasks: months[key]
      })
    }

    return groups
  }, [ props.tasks ])

  return (
    <div className="months-container"
      style={{
        overflow: 'auto',
      }}
    >
      <div>
        <div>
          {groupedByMonth.map((month: any, i: number) => (
            <div key={i} style={{ marginBottom: '1.5rem' }}>
              <KanbanMonth
                title={month.name}
                tasks={month.tasks.filter((task: any) => typeof task !== 'string')}
                onSelectTask={props.onSelectTask}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default TasksGroupByMonth
